import { Progress } from '@/components/ui/progress';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

const LevelBreakdown = ({ currentUserPoints }) => {
    const levels = Array.from({ length: 10 }, (_, i) => {
        const level = i + 1;
        return {
            level: level,
            xpRequired: Math.pow(level, 2) * 100,
        };
    });
    return (
        <Card className="w-full bg-transparent border-none shadow-none">
            <CardHeader className="flex flex-col gap-1">
                <CardTitle>Level Breakdown</CardTitle>
                <CardDescription>Your progress towards each XP level.</CardDescription>
            </CardHeader>
            <CardContent>
                <div className="flex flex-col gap-4">
                    {levels.map(({ level, xpRequired }) => {
                        const prevXpRequired = level > 1 ? Math.pow(level - 1, 2) * 100 : 0;
                        const xpForThisLevel = xpRequired - prevXpRequired;
                        const xpEarnedInThisLevel = Math.max(0, currentUserPoints - prevXpRequired);

                        const progress =
                            xpForThisLevel > 0
                                ? Math.min((xpEarnedInThisLevel / xpForThisLevel) * 100, 100)
                                : 0;

                        return (
                            <div key={level}>
                                <div className="flex justify-between items-center mb-2">
                                    <span className="font-semibold text-[14px] text-neutral-700 uppercase">
                                        Level {level}
                                    </span>
                                    <span className="text-sm text-neutral-700">
                                        {xpRequired.toLocaleString()} XP
                                    </span>
                                </div>
                                <Progress value={progress} className="h-3" />
                            </div>
                        );
                    })}
                </div>
            </CardContent>
        </Card>
    );
};

export default LevelBreakdown;
